const initialState = {
   isOpenAgeVerificationProcessModal: false,
   isOpenAgeVerifiedModal: false,
};

export default initialState;
